export const cardSemanticTokens = {
  bg: {
    solid: { value: "colors.gray.100" },
    solidActive: { value: "colors.green.500" },
    subtle: { value: "colors.primary.white" },
    outline: { value: "colors.primary.white" },
  },

  text: {
    solidActive: { value: "colors.primary.white" },
  },

  radii: {
    subtle: { value: "radii.xl" },
    outline: { value: "radii.lg" },
  },

  border: {
    solid: { value: "colors.gray.100" },
    solidActive: { value: "colors.green.500" },
    subtle: { value: "colors.gray.400" },
    subtleHover: { value: "colors.secondary.blue" },
    outline: { value: "colors.green.500" },
  },
};
